import {type IUser, UserSource} from '../schema/user/userSchema';
import {isPublicUser} from '../utils/isPublicUser';

export const canResetPassword = (user?: IUser) =>
	!!user &&
	user.userSource === UserSource.INTERNAL &&
	!user.disabled &&
	!isPublicUser(user.login);
